import React from 'react';
import { Grid, Typography } from "@mui/material";
import plumber1 from '../../../assets/plumber1.png'
import Invoice from './Invoice'

const JobCompletion = () => {
    return (
        <Grid display="flex" flexDirection='column' className="completion">
            <Typography style={{fontSize:'15px', fontWeight:'600', padding:'10px 0px'}}>Job Completion Details</Typography>
            <Grid display='flex' style={{marginLeft:'30px'}}>
               <Grid display="flex" flexDirection="column" style={{width:'40%'}}>
               <Typography style={{fontSize:'12px', color:'#202121'}}>Uploaded Invoices</Typography>
               <Invoice invoice="Parts invoice1.pdf"/>
               <Invoice invoice="Parts invoice2.pdf"/>
               </Grid>
               <Grid display="flex" flexDirection="column" style={{width:'40%'}}>
                <Typography style={{fontSize:'12px', color:'#202121'}}>Uploaded Images</Typography>
                <Grid display="flex" style={{margin:'4%', justifyContent:'space-between', paddingBottom:'10px'}}>
                    <img src={plumber1} alt="plumber"/>
                    <img src={plumber1} style={{marginLeft:'2%'}} alt="plumber"/>
                    <img src={plumber1} style={{marginLeft:'2%'}} alt="plumber"/>
                    <img src={plumber1} style={{marginLeft:'2%'}} alt="plumber"/>
                </Grid>
               </Grid>
            </Grid>
            </Grid>
    );
};

export default JobCompletion;